module.exports = __webpack_public_path__ + "img/blue_136.1bb16022.png";